// components/Header.jsx
import React, { useState, useEffect, useRef } from 'react';
import {
  FaBars,
  FaChevronDown,
  FaBell,
  FaUserCircle,
  FaIdCard,
  FaShieldAlt,
  FaPalette,
  FaQuestionCircle,
  FaSignOutAlt,
  FaGlobe,
  FaAndroid,
  FaLaptopCode,
  FaShoppingCart,
  FaPlusCircle,
  FaCheck,
  FaTimes
} from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

const pageTitles = {
  dashboard: 'Dashboard',
  'transaction-live': 'Live Transaction',
  analytics: 'Analytics',
  users: 'User Center',
  transaction: 'Transaction',
  dispute: 'Dispute',
  margin: 'Margin',
  api: 'API',
  setting: 'Setting',
  khatabook: 'Khatabook',
};

const pageSubTitles = {
  dashboard: 'Dashboard',
  'transaction-live': 'Live Transaction',
  analytics: 'Analytics',
  users: 'User Management',
  transaction: 'Find the below transactions',
  dispute: 'Dispute Management',
  margin: 'Margin Management',
  api: 'API Management',
  setting: 'Settings',
  khatabook: 'Khatabook',
};

const projects = [
  { id: 'main', label: 'Main Website', icon: FaGlobe, color: 'text-indigo-500' },
  { id: 'mobile', label: 'Mobile App', icon: FaAndroid, color: 'text-green-500' },
  { id: 'admin', label: 'Admin Portal', icon: FaLaptopCode, color: 'text-purple-500' },
  { id: 'ecom', label: 'E-commerce', icon: FaShoppingCart, color: 'text-blue-500' },
];

const Header = ({ currentPage, sidebarOpen, setSidebarOpen }) => {
  const [projectDropdownOpen, setProjectDropdownOpen] = useState(false);
  const [userDropdownOpen, setUserDropdownOpen] = useState(false);
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [isLoggingOut, setIsLoggingOut] = useState(false);
  const [selectedProject, setSelectedProject] = useState(projects[0]);
  const projectRef = useRef(null);
  const userRef = useRef(null);
  const modalRef = useRef(null);
  const [email, setEmail] = useState();
  const [mobile, setMobile] = useState();
  const [name, setName] = useState();
  const [user_id, setUserId] = useState();
  const navigate = useNavigate();


  const title = pageTitles[currentPage] || 'ProAdmin';
  const subTitle = pageSubTitles[currentPage] || 'Sub title';

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (projectRef.current && !projectRef.current.contains(e.target)) {
        setProjectDropdownOpen(false);
      }
      if (userRef.current && !userRef.current.contains(e.target)) {
        setUserDropdownOpen(false);
      }
    };
    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, []);

  const selectProject = (project) => {
    setSelectedProject(project);
    setProjectDropdownOpen(false);
  };

  const handleLogoutClick = () => {
    setUserDropdownOpen(false);
    setShowLogoutModal(true);
  };

  const handleCancelLogout = () => {
    setShowLogoutModal(false);
  };

  const handleConfirmLogout = () => {
    setIsLoggingOut(true);

    setTimeout(() => {
      // Clear all localStorage
      localStorage.clear();

      // Clear sessionStorage if needed
      // sessionStorage.clear();

      setShowLogoutModal(false);
      setIsLoggingOut(false);

      // Navigate to login page
      window.location.href = '/login';
      // If using React Router: navigate('/login');
    }, 500);
  };

  useEffect(() => {
    const storedUserData = localStorage.getItem("credentials");
    const parsedData = JSON.parse(storedUserData);

    setEmail(parsedData?.email || '');
    setMobile(parsedData?.mobile || '');
    setName(parsedData?.name || '');
    setUserId(parsedData?.user_id || '');
  }, [])

  const getInitials = (name) => {
    if (!name) return "";

    const parts = name.trim().split(/\s+/);

    if (parts.length === 1) {
      return parts[0][0].toUpperCase();
    }

    return (
      parts[0][0] + parts[parts.length - 1][0]
    ).toUpperCase();
  };

  return (
    <>
      <header className="bg-white border-b border-gray-200 sticky top-0 z-30 shadow-sm">
        <div className="px-3 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            {/* Left side - Page title */}
            <div className="hidden lg:block">
              <h1 className="text-xl font-semibold text-gray-800">{title}</h1>
              <p className="text-xs text-gray-500 mt-0.5">{subTitle}</p>
            </div>

            {/* Mobile menu toggle */}
            <button
              className="lg:hidden flex items-center"
              onClick={() => setSidebarOpen(!sidebarOpen)}
            >
              <div className="w-9 h-9 rounded-lg bg-gradient-to-br from-indigo-600 to-indigo-800 flex items-center justify-center shadow-md">
                <FaBars className="text-white text-sm" />
              </div>
            </button>

            {/* Right side - Actions */}
            <div className="flex items-center gap-2 sm:gap-3 ml-auto">
              {/* 
              <div ref={projectRef} className="relative">
                <button
                  onClick={() => setProjectDropdownOpen(!projectDropdownOpen)}
                  className="flex items-center gap-1 sm:gap-2 px-2 sm:px-3 py-2 rounded-lg border border-gray-200 bg-white hover:bg-gray-50 transition text-sm"
                >
                  <selectedProject.icon className={`w-4 h-4 ${selectedProject.color}`} />
                  <span className="hidden sm:inline font-medium text-gray-700">
                    {selectedProject.label}
                  </span>
                  <FaChevronDown
                    className={`text-gray-400 text-xs transition-transform duration-200 ${projectDropdownOpen ? 'rotate-180' : ''
                      }`}
                  />
                </button>

                {projectDropdownOpen && (
                  <div className="absolute right-0 mt-2 w-56 sm:w-64 bg-white rounded-lg shadow-lg border border-gray-100 py-2 z-50">
                    <div className="px-3 py-2 text-xs font-semibold text-gray-400 uppercase tracking-wider border-b border-gray-100">
                      Select Project
                    </div>
                    {projects.map((project) => (
                      <div
                        key={project.id}
                        onClick={() => selectProject(project)}
                        className="flex items-center gap-3 px-4 py-2.5 hover:bg-gray-50 cursor-pointer transition"
                      >
                        <project.icon className={`w-4 h-4 ${project.color}`} />
                        <span className="text-sm text-gray-700">{project.label}</span>
                        {selectedProject.id === project.id && (
                          <FaCheck className="ml-auto text-green-500 w-4 h-4" />
                        )}
                      </div>
                    ))}
                    <div className="border-t border-gray-100 mt-1 pt-1">
                      <a
                        href="#"
                        className="flex items-center gap-3 px-4 py-2.5 hover:bg-gray-50 transition text-sm text-indigo-600"
                      >
                        <FaPlusCircle className="w-4 h-4" />
                        <span>Manage Projects</span>
                      </a>
                    </div>
                  </div>
                )}
              </div>

               */}

              {/* Live */}
              <button
                className="flex items-center gap-2 px-3 py-1 text-gray-600 hover:text-gray-800 bg-gray-100 hover:bg-gray-200 rounded-lg transition"
                onClick={() => navigate("../transaction/live")}
              >
                {/* Green fading dot */}
                <span className="w-2.5 h-2.5 rounded-full bg-green-500 animate-pulse"></span>

                <span className="font-medium">Live</span>
              </button>

              {/* Notification Bell */}
              <button className="relative p-2 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-lg transition" onClick={() => navigate('../notification')}>
                <FaBell className="text-lg" />
                <span className="absolute top-1 right-1 w-2 h-2 bg-red-500 rounded-full" />
              </button>

              {/* User Profile */}
              <div ref={userRef} className="relative">
                <button
                  onClick={() => setUserDropdownOpen(!userDropdownOpen)}
                  className="flex items-center gap-2 p-1.5 rounded-lg hover:bg-gray-100 transition"
                >
                  <div className="w-8 h-8 rounded-full bg-gradient-to-r from-indigo-500 to-purple-500 flex items-center justify-center text-white text-sm font-semibold">
                    {getInitials(name)}
                  </div>
                  <div className="hidden md:block text-left">
                    <p className="text-sm font-medium text-gray-700">{name}</p>
                    <p className="text-xs text-gray-400">Administrator</p>
                  </div>
                  <FaChevronDown className="text-gray-400 text-xs hidden md:block" />
                </button>

                {userDropdownOpen && (
                  <div className="absolute right-0 mt-2 w-64 sm:w-72 bg-white rounded-lg shadow-lg border border-gray-100 py-2 z-50">
                    <div className="px-4 py-3 border-b border-gray-100">
                      <div className="flex items-center gap-3">
                        <div className="w-10 h-10 rounded-full bg-gradient-to-r from-indigo-500 to-purple-500 flex items-center justify-center text-white font-semibold">
                          {getInitials(name)}
                        </div>
                        <div>
                          <p className="text-sm font-semibold text-gray-800">{name}</p>
                          <p className="text-xs text-gray-500">{email}</p>
                        </div>
                      </div>
                    </div>

                    <div className="py-2">
                      <div onClick={() => navigate('../profile')} className="flex items-center gap-3 px-4 py-2.5 hover:bg-gray-50 transition text-sm text-gray-700 cursor-pointer">
                        <FaUserCircle className="w-5 h-5 text-gray-400" />
                        <span>My Profile</span>
                      </div>
                      <div onClick={() => navigate('../notification')} className="flex items-center gap-3 px-4 py-2.5 hover:bg-gray-50 transition text-sm text-gray-700 cursor-pointer">
                        <FaBell className="w-5 h-5 text-gray-400" />
                        <span>Notifications</span>
                        <span className="ml-auto bg-red-100 text-red-600 text-xs px-2 py-0.5 rounded-full">3</span>
                      </div>
                      <div onClick={() => navigate('../theme')} className="flex items-center gap-3 px-4 py-2.5 hover:bg-gray-50 transition text-sm text-gray-700 cursor-pointer">
                        <FaPalette className="w-5 h-5 text-gray-400" />
                        <span>Theme Settings</span>
                      </div>
                    </div>

                    <div className="border-t border-gray-100 pt-2">
                      <div onClick={() => navigate('../support')} className="flex items-center gap-3 px-4 py-2.5 hover:bg-gray-50 transition text-sm text-gray-700 cursor-pointer">
                        <FaQuestionCircle className="w-5 h-5 text-gray-400" />
                        <span>Help & Support</span>
                      </div>
                      <div
                        onClick={handleLogoutClick}
                        className="flex items-center gap-3 px-4 py-2.5 hover:bg-red-50 transition text-sm text-red-600 cursor-pointer"
                      >
                        <FaSignOutAlt className="w-5 h-5" />
                        <span>Logout</span>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* Simple Logout Confirmation Modal */}
      {showLogoutModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div
            ref={modalRef}
            className="bg-white rounded-lg shadow-xl max-w-md w-full mx-4"
          >
            {/* Modal Header */}
            <div className="flex items-center justify-between p-4 border-b border-gray-200">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-red-100 flex items-center justify-center">
                  <FaSignOutAlt className="w-5 h-5 text-red-600" />
                </div>
                <h3 className="text-lg font-semibold text-gray-900">Confirm Logout</h3>
              </div>
              <button
                onClick={handleCancelLogout}
                className="text-gray-400 hover:text-gray-600"
                disabled={isLoggingOut}
              >
                <FaTimes className="w-5 h-5" />
              </button>
            </div>

            {/* Modal Body */}
            <div className="p-4">
              <p className="text-gray-600">
                Are you sure you want to logout? All session data will be cleared.
              </p>
            </div>

            {/* Modal Footer */}
            <div className="flex justify-end gap-3 p-4 border-t border-gray-200 bg-gray-50 rounded-b-lg">
              <button
                onClick={handleCancelLogout}
                className="px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-200 rounded transition"
                disabled={isLoggingOut}
              >
                Cancel
              </button>
              <button
                onClick={handleConfirmLogout}
                disabled={isLoggingOut}
                className={`px-4 py-2 text-sm font-medium text-white rounded transition flex items-center gap-2 ${isLoggingOut
                  ? 'bg-red-400 cursor-not-allowed'
                  : 'bg-red-600 hover:bg-red-700'
                  }`}
              >
                {isLoggingOut ? (
                  <>
                    <svg className="animate-spin h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    Logging out...
                  </>
                ) : (
                  'Yes, Logout'
                )}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Header;